import { render } from "./PropertyDefaultWrapper.vue?vue&type=template&id=218ce00f&ts=true"
import script from "./PropertyDefaultWrapper.vue?vue&type=script&lang=ts"
export * from "./PropertyDefaultWrapper.vue?vue&type=script&lang=ts"

import "./PropertyDefaultWrapper.vue?vue&type=style&index=0&id=218ce00f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__